import React, { useEffect } from 'react'
import './addplant-style.scss'
import Accordion from '@mui/material/Accordion'
import AccordionSummary from '@mui/material/AccordionSummary'
import AccordionDetails from '@mui/material/AccordionDetails'
import Typography from '@mui/material/Typography'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore'
import Box from '@mui/material/Box'
import Grid from '@mui/material/Grid'
import { useNavigate, useLocation } from 'react-router-dom'
import { useFormik } from 'formik'
import * as Yup from 'yup'
import {
  CreatenewplantNew,
  UpdatenewplantNew,
  FetchSensorListNew,
  FetchDeviceListNew,
} from '../../services/api'
import PlantDetails from './components/PlantDetails/PlantDetails'
import ClientDetails from './components/ClientDetails/ClientDetails'
import EquipmentDetails from './components/EquipmentDetails/EquipmentDetails'
import OrganizationDetails from './components/OrganizationDetails/OrganizationDetails'
import CustomAlert from '../../components/CustomAlert/CustomAlert'
import useAddNewPlantStyles from './styles.js'
import MacIdAdd from './components/MacIdAdd/MacIdAdd'
import dayjs from 'dayjs'
import Estimation from './components/Estimation/Estimation'
import CircularProgress from '@mui/material/CircularProgress'

const AddNewPlant = () => {
  const classes = useAddNewPlantStyles()
  const navigate = useNavigate()

  const [alertState, setAlertState] = React.useState({
    open: false,
    message: '',
    severity: 'success',
  })
  const [devicelist, setDevicelist] = React.useState([])
  const [pyranometerSensorlist, setPyranometerSensorlist] = React.useState([])

  const { state } = useLocation()
  console.log(state, 'typee statessss')
  console.log(
    'state?.plantData?.roofDetails?',
    state?.plantData?.roofDetails[0]?.energyMeters[0]?.macId
  )

  useEffect(() => {
    FetchDeviceListNew(state?.token).then((resp) => {
      if (resp?.data) {
        console.log(resp?.data, 'FetchDeviceList resp')
        setDevicelist(resp?.data?.data)
      } else {
      }
    })
    FetchSensorListNew(state?.token).then((resp) => {
      if (resp?.data) {
        console.log(resp?.data, ' resp')
        setPyranometerSensorlist(resp?.data)
      } else {
      }
    })
  }, [state?.token])

  const InitialValues = state?.Edit
    ? {
      plantDetails: {
        plantName: state?.plantData?.plantName,
        plantLocation: state?.plantData?.plantLocation,
        plantSize: state?.plantData?.plantSizeKW,
        subContractorAccess: state?.plantData?.subContractorAccess,
        isMonitoring: state?.plantData?.isMonitoring !== undefined ? state?.plantData?.isMonitoring : true,
        //new
        interestRate: state?.plantData?.interestRate || 0,
        paymentTermsDays: state?.plantData?.paymentTermsDays || 7,
        legalNoticeDays: state?.plantData?.legalNoticeDays || 30,
        proposalType: {
          type: state?.plantData?.proposalType?.type || '',
          monthlyEmiAmount:
            state?.plantData?.proposalType?.monthlyEmiAmount || '',
          monthlyOMAmount:
            state?.plantData?.proposalType?.monthlyOMAmount || '',
          totalMonthlyAmount:
            state?.plantData?.proposalType?.totalMonthlyAmount || '',
          tariffEscalation:
            state?.plantData?.proposalType?.tariffEscalation || '',
          tariff: Number(state?.plantData?.proposalType?.tariff) || 0,
        },
        projectCode: state?.plantData?.projectCode,
        industryType: state?.plantData?.industryType,
        latitude: state?.plantData?.latitude,
        longitude: state?.plantData?.longitude,
        tenure: state?.plantData?.tenure,
        currency: state?.plantData?.currency,
        commissionDate: dayjs(state?.plantData?.commissionDate),
        completionDate: dayjs(state?.plantData?.completionDate),
        plantTimeZone: state?.plantData?.plantTimeZone,
        plantDocsId: state?.plantData?.plantDocsId || [],
        gridStatus: state?.plantData?.gridStatus,
        plantType: state?.plantData?.plantType,
        estimatedYield:
          state?.plantData?.estimatedYield ||
          state?.plantData?.estimatedYieldValue ||
          {},
        estimatedYieldValue: state?.plantData?.estimatedYieldValue,
        estimatedGTI:
          state?.plantData?.estimatedGTI ||
          state?.plantData?.estimatedGTIValue ||
          {},
        estimatedGTIValue: state?.plantData?.estimatedGTIValue,
        estimatedGeneration:
          state?.plantData?.estimatedGeneration ||
          state?.plantData?.estimatedGenerationValue ||
          {},
        estimatedGenerationValue: state?.plantData?.estimatedGenerationValue,
        degradationFactor: state?.plantData?.degradationFactor || 0,
        minimumGuaranteed:
          state?.plantData?.minimumGuaranteed ||
          state?.plantData?.minimumGuaranteedValue ||
          {},
        minimumGuaranteedValue: state?.plantData?.minimumGuaranteedValue,
        investorGuaranteed:
          state?.plantData?.investorGuaranteed ||
          state?.plantData?.investorGuaranteedValue ||
          {},
        investorGuaranteedValue: state?.plantData?.investorGuaranteedValue,
        estimation: state?.plantData?.estimation || {
          estimatedYeild: '',
          estimatedGti: '',
          degradationFactor: 0,
          minimumGuarantee: '',
        },
        simSerialNumber: state?.plantData?.simSerialNumber || '',
        simNetwork: state?.plantData?.simNetwork || '',
        networkProvier: state?.plantData?.networkProvier || '',
        dongleSerialNumber: state?.plantData?.dongleSerialNumber || '',
      },
      clientDetails: {
        clientName: state?.plantData?.entity?.entityName || '',
        contactNumber: state?.plantData?.entity?.primaryPhone || '',
        email: Array.isArray(state?.plantData?.entity?.primaryEmail)
          ? state?.plantData?.entity?.primaryEmail
          : [state?.plantData?.entity?.primaryEmail || ''],
        ccEmail: Array.isArray(state?.plantData?.entity?.ccEmail)
          ? state?.plantData?.entity?.ccEmail
          : [state?.plantData?.entity?.ccEmail || ''],
        designation: state?.plantData?.entity?.designation || '',
        clientAccess: state?.plantData?.entity?.clientAccess || false,
        gst: state?.plantData?.entity?.gst || '',
        panNumber: state?.plantData?.entity?.panNumber || '',
        billerDetails: {
          nameOfTheBank:
            state?.plantData?.entity?.billerDetails?.nameOfTheBank || '',
          ifscCode: state?.plantData?.entity?.billerDetails?.ifscCode || '',
          addressOfTheBank:
            state?.plantData?.entity?.billerDetails?.addressOfTheBank || '',
          entityName:
            state?.plantData?.entity?.billerDetails?.entityName ||
            state?.plantData?.entity?.entityName ||
            '',
          entityAddress:
            state?.plantData?.entity?.billerDetails?.entityAddress || '',
          accountNumber:
            state?.plantData?.entity?.billerDetails?.accountNumber || '',
          billToAddress:
            state?.plantData?.entity?.billerDetails?.billToAddress ||
            state?.plantData?.entity?.address ||
            '',
        },
      },
      organizationDetails: {
        organizationName: state?.plantData?.organization?.organizationName || '',
        organizationCode: state?.plantData?.organization?.organizationCode || state?.plantData?.organizationCode || '',
        email: state?.plantData?.organization?.email || '',
        phone: state?.plantData?.organization?.phone || '',
        website: state?.plantData?.organization?.website || '',
        address: state?.plantData?.organization?.address?.street || '',
        gstNumber: state?.plantData?.organization?.gstNumber || '',
        description: state?.plantData?.organization?.description || '',
        billerDetails: {
          nameOfTheBank: state?.plantData?.organization?.businessInfo?.nameOfTheBank || '',
          ifscCode: state?.plantData?.organization?.businessInfo?.ifscCode || '',
          addressOfTheBank: state?.plantData?.organization?.businessInfo?.addressOfTheBank || '',
          entityName: state?.plantData?.organization?.businessInfo?.entityName || '',
          accountNumber: state?.plantData?.organization?.businessInfo?.accountNumber || '',
          billToAddress: state?.plantData?.organization?.businessInfo?.billToAddress || '',
          entityAddress: state?.plantData?.organization?.businessInfo?.entityAddress || '',
        },
      },
      roofDetails:
        state?.plantData?.roofDetails?.map((data) => ({
          id: data?.id,
          roofLocation: data?.roofLocation,
          roofType: data?.roofType,
          orientation: data?.orientation,
          f1ModuleFacing: data?.f1ModuleFacing,
          f2ModuleFacing: data?.f2ModuleFacing,
          t1TiltAngle: data?.t1TiltAngle,
          t2TiltAngle: data?.t2TiltAngle,
          a1Azimuth: data?.a1Azimuth,
          a2Azimuth: data?.a2Azimuth,
          m1Modules: data?.m1Modules,
          m2Modules: data?.m2Modules,
          noOfInverters: data?.inverters?.length || 0,
          noOfStrings: data?.inverters?.[0]?.noOfStrings || 0,
          dcCapacity: data?.capacity || 0,
          serialNumber: data?.serialNumber,
          energyMeterLocation: data?.energyMeterLocation,
          energyMeterMakeAndModel: data?.energyMeters?.[0]?.type || '',
          ctRatio: data?.energyMeters?.[0]?.ctRatio || 0,
          tiltAngle: data?.tilt || 0,
          pyranometerLocation: data?.pyranometerLocation,
          pyranometerMakeAndModel: data?.pyranometerMakeAndModel,
          multiplyFactorGhiToGti: data?.multiplyingFactor || 0,
          pyranometerSerialNumber: data?.pyranometerSerialNumber,
          pyranometerActivationDate: data?.pyranometerActivationDate
            ? dayjs(data?.pyranometerActivationDate)
            : null,
          deviceId:
            data?.energyMeters?.[0]?.macId ||
            data?.inverters?.[0]?.macId ||
            '',
          // Add MAC ID (global for the roof/datalogger)
          macId:
            data?.energyMeters?.[0]?.macId ||
            data?.inverters?.[0]?.macId ||
            '',
          // Add datalogger fields with actual values from API
          dataloggerMake: data?.dataloggerMake || 'Wattmon',
          dataloggerModel: data?.dataloggerModel || 'Wattmon CSV Logger',
          energyMeters:
            data?.energyMeters?.map((devData) => ({
              id: devData?.id,
              deviceTypeId: devData?.deviceTypeId,
              slaveId: devData?.slaveId,
              serialNumber: devData?.serialNumber,
              meterConnectedDcCapacity: devData?.meterConnectedDcCapacity,
              scalingFactor: devData?.scalingFactor,
              energyMeterMakeAndModel:
                devData?.type || devData?.energyMeterMakeAndModel,
              ctRatio: devData?.ctRatio,
              energyRadio: devData?.energyRadio || 0,
              deviceMake: devData?.make,
              deviceModel: devData?.model,
              macId: devData?.macId,
              channel:
                devData?.channel || devData?.dataloggerSlaveMap?.channel || 1,
            })) || [],
          inverters:
            data?.inverters?.map((devData) => ({
              id: devData?.id,
              deviceTypeId: devData?.deviceTypeId,
              slaveId: devData?.slaveId,
              InverterSerialNumber:
                devData?.InverterSerialNumber || devData?.serialNumber,
              acCapacity: devData?.acCapacity,
              deviceMake: devData?.make || devData?.deviceMake,
              deviceModel: devData?.model || devData?.deviceModel,
              noOfStrings: devData?.noOfStrings,
              dcCapacity: devData?.dcCapacity,
              macId: devData?.macId,
              channel:
                devData?.channel || devData?.dataloggerSlaveMap?.channel || 1,
            })) || [],
          pyranoMeter: {
            deviceId: data?.pyranoMeter?.deviceId || '',
            deviceTypeId: data?.pyranoMeter?.deviceTypeId || 0,
            multiplyingFactor: Number(
              data?.pyranoMeter?.multiplyingFactor ||
              data?.multiplyingFactor ||
              0
            ),
            multiplyingFactorOg: Number(
              data?.pyranoMeter?.multiplyingFactorOg ||
              data?.multiplyingFactor ||
              0
            ),
            pyranometerSerialNumber:
              data?.pyranoMeter?.pyranometerSerialNumber || '',
            pyranometerActivationDate:
              data?.pyranoMeter?.pyranometerActivationDate || '',
            pyranometerMakeAndModel:
              data?.pyranoMeter?.pyranometerMakeAndModel || '',
            tiltAngle: data?.pyranoMeter?.tiltAngle || data?.tilt || '',
            sensorId: data?.pyranoMeter?.sensorId || '',
            slaveId:
              data?.pyranoMeter?.slaveId || data?.sensors?.[0]?.slaveId || '',
            macId:
              data?.pyranoMeter?.macId || data?.sensors?.[0]?.macId || '',
            channel:
              data?.pyranoMeter?.channel ||
              data?.sensors?.[0]?.channel ||
              data?.sensors?.[0]?.dataloggerSlaveMap?.channel ||
              2,
            deviceMake:
              data?.pyranoMeter?.make || data?.sensors?.[0]?.make || '',
            deviceModel:
              data?.pyranoMeter?.model || data?.sensors?.[0]?.model || '',
            forwardPyranometerData: !!data?.pyranoMeter || false,
          },
        })) || [],
    }
    : {
      plantDetails: {
        plantName: '',
        plantLocation: '',
        plantSize: '',
        subContractorAccess: false,
        isMonitoring: true,
        interestRate: 0,
        legalNoticeDays: 30,
        paymentTermsDays: 7,
        proposalType: {
          type: '',
          monthlyEmiAmount: '',
          monthlyOMAmount: '',
          totalMonthlyAmount: '',
          tariffEscalation: '',
          tariff: '',
        },
        projectCode: '',
        industryType: '',
        latitude: 0,
        longitude: 0,
        tenure: '',
        currency: 'INR',
        commissionDate: null,
        completionDate: null,
        plantTimeZone: 'Asia/Kolkata',
        plantDocsId: [],
        gridStatus: '',
        plantType: '',
        estimatedYield: {},
        estimatedGTI: {},
        estimatedGeneration: {},
        degradationFactor: 0,
        minimumGuaranteed: {},
        investorGuaranteed: {},
        estimation: {
          estimatedYeild: '',
          estimatedGti: '',
          degradationFactor: 0,
          minimumGuarantee: '',
        },
        simSerialNumber: '',
        simNetwork: '',
        networkProvier: '',
        dongleSerialNumber: '',
      },
      clientDetails: {
        clientName: '',
        contactNumber: '',
        email: [''],
        ccEmail: [''],
        designation: '',
        clientAccess: false,
        gst: '',
        panNumber: '',
        billerDetails: {
          nameOfTheBank: '',
          ifscCode: '',
          addressOfTheBank: '',
          entityName: '',
          entityAddress: '',
          accountNumber: '',
          billToAddress: '',
        },
      },
      organizationDetails: {
        organizationName: '',
        organizationCode: '',
        email: '',
        phone: '',
        website: '',
        address: '',
        gstNumber: '',
        description: '',
        billerDetails: {
          nameOfTheBank: '',
          ifscCode: '',
          addressOfTheBank: '',
          entityName: '',
          accountNumber: '',
          billToAddress: '',
          entityAddress: '',
        },
      },
      roofDetails: [
        {
          roofLocation: '',
          roofType: '',
          orientation: '',
          f1ModuleFacing: '',
          f2ModuleFacing: '',
          t1TiltAngle: 0,
          t2TiltAngle: 0,
          a1Azimuth: 0,
          a2Azimuth: 0,
          m1Modules: 0,
          m2Modules: 0,
          noOfInverters: 0,
          noOfStrings: 0,
          dcCapacity: 0,
          serialNumber: '',
          energyMeterLocation: '',
          energyMeterMakeAndModel: '',
          ctRatio: 0,
          tiltAngle: 0,
          pyranometerLocation: '',
          pyranometerMakeAndModel: '',
          pyranometerSerialNumber: '',
          multiplyFactorGhiToGti: 0,
          deviceId: '',
          // Add MAC ID field for new plants
          macId: '',
          // Add default values for datalogger fields
          dataloggerMake: 'Wattmon',
          dataloggerModel: 'Wattmon CSV Logger',
          energyMeters: [
            {
              energyRadio: 0,
              slaveId: '',
              macId: '',
              channel: 1,
              deviceMake: '',
              deviceModel: '',
              serialNumber: '',
              meterConnectedDcCapacity: 0,
              scalingFactor: 0,
              energyMeterMakeAndModel: '',
              ctRatio: 0,
            },
          ],
          inverters: [
            {
              deviceTypeId: '',
              slaveId: '',
              InverterSerialNumber: '',
              acCapacity: 0,
              deviceMake: '',
              deviceModel: '',
              noOfStrings: 0,
              dcCapacity: 0,
              macId: '',
              channel: 1,
            },
          ],
          pyranoMeter: {
            deviceId: '',
            deviceTypeId: 0,
            multiplyingFactor: 0,
            multiplyingFactorOg: 0,
            pyranometerSerialNumber: '',
            pyranometerActivationDate: '',
            pyranometerMakeAndModel: '',
            tiltAngle: '',
            sensorId: '',
            channel: 1,
            forwardPyranometerData: false,
          },
        },
      ],
    }

  // Dynamic validation schema based on isMonitoring flag
  const getValidationSchema = (isMonitoringValue = InitialValues?.plantDetails?.isMonitoring) => {
    const isMonitoring = isMonitoringValue === true

    return Yup.object().shape({
      plantDetails: Yup.object().shape({
        plantName: Yup.string().required('Plant Name is required'),
        commissionDate: Yup.string().required('Commission Date is required'),
        completionDate: Yup.string().required('Completion Date is required'),
        plantSize: Yup.number()
          .typeError('Plant Size must be a number')
          .required('Plant Size is required'),
        gridStatus: Yup.string().required('Grid Status is required'),
        isMonitoring: Yup.boolean(),
        proposalType: Yup.object().shape({
          type: Yup.string().required('Proposal Type is required'),
          tariff: Yup.number()
            .typeError('Tariff must be a number')
            .required('Tariff is required'),
        }),
        interestRate: Yup.number()
          .typeError('Interest Rate must be a number')
          .required('Interest Rate is required'),
        legalNoticeDays: Yup.number()
          .typeError('Legal Notice Days must be a number')
          .required('Legal Notice Days is required'),
        paymentTermsDays: Yup.number()
          .typeError('Payment Terms Days must be a number')
          .required('Payment Terms Days is required'),
        tenure: Yup.number()
          .typeError('Tenure must be a number')
          .required('Tenure is required'),
      }),
      clientDetails: Yup.object().shape({
        clientName: Yup.string().required('Client Name is required'),
        email: Yup.array()
          .of(
            Yup.string()
              .email('Email must be valid')
              .required('Email is required')
          )
          .min(1, 'At least one email is required'),
        ccEmail: Yup.array()
          .of(
            Yup.string()
              .email('Email must be valid')
              .required('CC Email is required')
          )
          .min(1, 'At least one CC Email is required'),
        contactNumber: Yup.string().required('Contact Number is required'),
      }),
      organizationDetails: Yup.object().shape({
        organizationCode: Yup.string().required('Organization Code is required'),
        organizationName: Yup.string().required('Organization Name is required'),
        address: Yup.string().required('Organization Address is required'),
      }),
      roofDetails: Yup.array().of(
        Yup.lazy((obj) =>
          Yup.object().shape({
            dataloggerMake: Yup.string().required('Datalogger Make is required'),
            dataloggerModel: Yup.string().required('Datalogger Model is required'),
            // macId validation is conditional on isMonitoring
            ...(isMonitoring && {
              macId: Yup.string().required('MAC ID is required'),
            }),
            energyMeters: Yup.array().of(
              Yup.object().shape({
                deviceMake: Yup.string().required('Energy Meter Device Make is required'),
                deviceModel: Yup.string().required('Energy Meter Device Model is required'),
                // slaveId and channel are conditional on isMonitoring
                ...(isMonitoring && {
                  slaveId: Yup.number()
                    .typeError('Slave ID must be a number')
                    .required('Slave ID is required')
                    .test('min-value', 'Slave ID must be >= 1', (value) => {
                      if (!value && value !== 0) return true
                      return value >= 1
                    }),
                  channel: Yup.number()
                    .typeError('Channel must be a number')
                    .required('Channel is required'),
                }),
              })
            ),
            inverters: Yup.array().of(
              Yup.object().shape({
                deviceMake: Yup.string().required('Inverter Device Make is required'),
                deviceModel: Yup.string().required('Inverter Device Model is required'),
                // slaveId and channel are conditional on isMonitoring
                ...(isMonitoring && {
                  slaveId: Yup.number()
                    .typeError('Slave ID must be a number')
                    .required('Slave ID is required')
                    .test('min-value', 'Slave ID must be >= 1', (value) => {
                      if (!value && value !== 0) return true
                      return value >= 1
                    }),
                  channel: Yup.number()
                    .typeError('Channel must be a number')
                    .required('Channel is required'),
                }),
              })
            ),
            pyranoMeter: Yup.object().shape({
              deviceMake: obj?.pyranoMeter?.available
                ? Yup.string().required('Pyranometer Device Make is required')
                : Yup.string().notRequired(),
              deviceModel: obj?.pyranoMeter?.available
                ? Yup.string().required('Pyranometer Device Model is required')
                : Yup.string().notRequired(),
              ...(isMonitoring && obj?.pyranoMeter?.available && {
                slaveId: Yup.number()
                  .typeError('Slave ID must be a number')
                  .required('Slave ID is required')
                  .test('min-value', 'Slave ID must be >= 1', (value) => {
                    if (!value && value !== 0) return true
                    return value >= 1
                  }),
                channel: Yup.number()
                  .typeError('Channel must be a number')
                  .required('Channel is required'),
              }),
            }),
          })
        )
      ),
    })
  }

  const [validationSchema, setValidationSchema] = React.useState(getValidationSchema())

  const formik = useFormik({
    initialValues: InitialValues,
    validationSchema,
    onSubmit: (values) => {
      const processedValues = {
        plantDetails: {
          ...values.plantDetails,
          // Ensure tariff is properly set if proposalType exists
          ...(values.plantDetails.proposalType && {
            proposalType: {
              ...values.plantDetails.proposalType,
              tariff: values.plantDetails.proposalType.tariff ? Number(values.plantDetails.proposalType.tariff) : undefined,
            },
          }),
          simSerialNumber: values.plantDetails.simSerialNumber || '',
          simNetwork: values.plantDetails.simNetwork || '',
          networkProvier: values.plantDetails.networkProvier || '',
          dongleSerialNumber: values.plantDetails?.dongleSerialNumber || '',
        },
        clientDetails: values.clientDetails,
        organizationDetails: values.organizationDetails,
        roofDetails: values.roofDetails.map((roof) => {
          const isMonitoringEnabled = values.plantDetails?.isMonitoring;

          // Check if pyranoMeter has meaningful data
          const hasPyranometerData =
            roof.pyranoMeter?.deviceMake?.trim() ||
            roof.pyranoMeter?.deviceModel?.trim() ||
            (roof.pyranoMeter?.slaveId && roof.pyranoMeter?.slaveId > 0) ||
            roof.pyranoMeter?.pyranometerSerialNumber?.trim() ||
            roof.pyranoMeter?.pyranometerMakeAndModel?.trim();

          return {
            deviceId: String(roof.deviceId || roof.macId || ''),
            dataloggerMake: String(roof.dataloggerMake || 'Wattmon'),
            dataloggerModel: String(roof.dataloggerModel || 'Wattmon CSV Logger'),
            roofLocation: String(roof.roofLocation || ''),
            orientation: String(roof.orientation || ''),
            f1ModuleFacing: String(roof.f1ModuleFacing || ''),
            f2ModuleFacing: String(roof.f2ModuleFacing || ''),
            t1TiltAngle: Number(roof.t1TiltAngle || 0),
            t2TiltAngle: Number(roof.t2TiltAngle || 0),
            a1Azimuth: Number(roof.a1Azimuth || 0),
            a2Azimuth: Number(roof.a2Azimuth || 0),
            m1Modules: Number(roof.m1Modules || 0),
            m2Modules: Number(roof.m2Modules || 0),
            // Ensure energyMeters structure is correct
            energyMeters: roof.energyMeters.map((meter) => {
              const energyMeterObj = {
                deviceMake: String(meter.deviceMake || ''),
                deviceModel: String(meter.deviceModel || ''),
                channel: meter.channel && Number(meter.channel) > 0 ? Number(meter.channel) : 1,
                serialNumber: String(meter.serialNumber || ''),
                meterConnectedDcCapacity: Number(
                  meter.meterConnectedDcCapacity || 0
                ),
                scalingFactor: Number(meter.scalingFactor || 0),
                energyMeterMakeAndModel: String(
                  meter.energyMeterMakeAndModel || ''
                ),
                ctRatio: Number(meter.ctRatio || 0),
              };
              // Only include slaveId if isMonitoring is true
              if (isMonitoringEnabled) {
                energyMeterObj.slaveId = meter.slaveId && Number(meter.slaveId) > 0 ? Number(meter.slaveId) : 1;
              }
              return energyMeterObj;
            }),
            // Ensure inverters structure is correct
            inverters: roof.inverters.map((inverter) => {
              const inverterObj = {
                deviceMake: String(inverter.deviceMake || ''),
                deviceModel: String(inverter.deviceModel || ''),
                channel: inverter.channel && Number(inverter.channel) > 0 ? Number(inverter.channel) : 1,
                InverterSerialNumber: String(inverter.InverterSerialNumber || ''),
                acCapacity: Number(inverter.acCapacity || 0),
                dcCapacity: Number(inverter.dcCapacity || 0),
                noOfStrings: Number(inverter.noOfStrings || 0),
              };
              // Only include slaveId if isMonitoring is true
              if (isMonitoringEnabled) {
                inverterObj.slaveId = inverter.slaveId && Number(inverter.slaveId) > 0 ? Number(inverter.slaveId) : 1;
              }
              return inverterObj;
            }),
            // Only include pyranoMeter if meaningful data is provided
            ...(hasPyranometerData
              ? {
                pyranoMeter: (() => {
                  const pyroObj = {
                    deviceMake: String(roof.pyranoMeter?.deviceMake || ''),
                    deviceModel: String(roof.pyranoMeter?.deviceModel || ''),
                    channel: roof.pyranoMeter?.channel && Number(roof.pyranoMeter?.channel) > 0 ? Number(roof.pyranoMeter?.channel) : 1,
                    pyranoMeterSerialNumber: String(
                      roof.pyranoMeter?.pyranoMeterSerialNumber || ''
                    ),
                    multiplyingFactor: Number(roof.pyranoMeter?.multiplyingFactor) || 0,
                  };
                  // Only include slaveId if isMonitoring is true
                  if (isMonitoringEnabled) {
                    pyroObj.slaveId = roof.pyranoMeter?.slaveId && Number(roof.pyranoMeter?.slaveId) > 0 ? Number(roof.pyranoMeter?.slaveId) : 1;
                  }
                  return pyroObj;
                })(),
              }
              : {}),
          };
        }),
      }

      if (state?.Edit === true) {
        UpdatenewplantNew({
          values: processedValues,
          Id: state?.plantData?.id,
          token: state?.token,
        })
          .then((resp) => {
            console.log('edit plant data', processedValues)

            if (resp?.data) {
              console.log(resp?.data, 'resp edit plant data')
              setAlertState({
                open: true,
                message: 'Plant Updated Successfully',
                severity: 'success',
              })
              navigate('/solarplantlist')
            } else {
              setAlertState({
                open: true,
                message: resp?.error?.message || 'Failed to update plant',
                severity: 'error',
              })
            }
          })
          .catch((error) => {
            console.error('Error updating plant:', error)
            setAlertState({
              open: true,
              message:
                error?.response?.data?.error?.message ||
                error?.message ||
                'Failed to update plant. Please try again.',
              severity: 'error',
            })
          })
          .finally(() => {
            // Reset formik submitting state
            formik.setSubmitting(false)
          })
      } else {
        console.log('plant data format', processedValues)
        CreatenewplantNew(processedValues, state?.token)
          .then((resp) => {
            console.log('plant data', processedValues)

            if (resp?.data) {
              console.log(resp?.data, 'resp')
              setAlertState({
                open: true,
                message: 'Plant Added Successfully',
                severity: 'success',
              })
              navigate('/solarplantlist')
            } else {
              setAlertState({
                open: true,
                message: resp?.error?.message || 'Failed to add plant',
                severity: 'error',
              })
            }
          })
          .catch((error) => {
            console.error('Error creating plant:', error)
            setAlertState({
              open: true,
              message:
                error?.response?.data?.error?.message ||
                error?.message ||
                'Failed to add plant. Please try again.',
              severity: 'error',
            })
          })
          .finally(() => {
            // Reset formik submitting state
            formik.setSubmitting(false)
          })
      }
    },
  })

  // Update validation schema when isMonitoring changes
  useEffect(() => {
    const newSchema = getValidationSchema(formik.values.plantDetails?.isMonitoring)
    setValidationSchema(newSchema)
    // Validate all fields with the new schema
    formik.validateForm(formik.values)
  }, [formik.values.plantDetails?.isMonitoring])

  const handleFormSubmit = async (e) => {
    e.preventDefault()

    // Prevent double submission
    if (formik.isSubmitting) {
      return
    }

    const errors = await formik.validateForm()
    console.log('Form errors:', errors)

    const hasErrorsInSpecificFields =
      errors?.plantDetails?.plantName &&
      errors?.plantDetails?.tenure &&
      errors?.plantDetails?.commissionDate &&
      errors?.plantDetails?.completionDate &&
      errors?.roofDetails?.some((roof, index) =>
        errors.roofDetails[index]?.inverters?.some(
          (inverter, inverterIndex) =>
            errors.roofDetails[index].inverters[inverterIndex]?.deviceTypeId &&
            errors.roofDetails[index].inverters[inverterIndex]?.slaveId &&
            errors.roofDetails[index].inverters[inverterIndex]?.deviceId
        )
      )

    if (hasErrorsInSpecificFields) {
      setAlertState({
        open: true,
        message: 'Check the form for errors',
        severity: 'error',
      })
      formik.setSubmitting(false)
    } else {
      formik.handleSubmit()
    }
  }

  useEffect(() => {
    if (formik.submitCount > 0) {
      if (!formik.isValid) {
        setAlertState({
          open: true,
          message: 'Please correct the errors in the form',
          severity: 'error',
        })
        // Reset submitting state if form is invalid
        formik.setSubmitting(false)
      } else {
        setAlertState({ ...alertState, open: false })
      }
    }
  }, [formik.submitCount, formik.isValid])

  const handleAlertClose = (event, reason) => {
    if (reason === 'clickaway') return
    setAlertState({
      ...alertState,
      open: false,
    })
  }

  console.log(formik.values, 'formik')

  return (
    <>
      <CustomAlert
        open={alertState.open}
        handleClose={handleAlertClose}
        message={alertState.message}
        severity={alertState.severity}
      />
      <div className={classes.root} id="add_new_plant">
        <form onSubmit={handleFormSubmit}>
          {' '}
          <div>
            <Box style={{ padding: '10px' }}>
              <Grid container spacing={2} className="page_h_b">
                <Grid item xs={12} md={6}>
                  <div className="page_h_txt">
                    {state?.Edit === true
                      ? `Edit Plant : ${formik?.values?.plantDetails?.plantName}`
                      : 'Add New Plant'}{' '}
                  </div>
                </Grid>
              </Grid>
              <div className="page_h_bUnderLine"></div>
            </Box>
          </div>
          <div style={{ padding: '10px' }}>
            <Accordion
              className="mb_20"
              classes={{ root: 'MuiPaper-root-MuiAccordion-root' }}
              style={{
                '&:before': {
                  display: 'none !important',
                  backgroundColor: 'none',
                  border: 'none',
                },
                '& MuiPaper-root-MuiAccordion-root': {
                  boxShadow: 'none !impotant',
                },
              }}
            >
              <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel1a-content"
                id="panel1a-header"
                className="accordion_h"
              >
                <Typography>Plant Details</Typography>
              </AccordionSummary>
              <AccordionDetails className="accordion_b">
                <PlantDetails formik={formik} />
              </AccordionDetails>
            </Accordion>

            <Accordion
              className="mb_20"
              classes={{ root: 'MuiPaper-root-MuiAccordion-root' }}
            >
              <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel2a-content"
                id="panel2a-header"
                className="accordion_h"
              >
                <Typography>Entity Details</Typography>
              </AccordionSummary>
              <AccordionDetails className="accordion_b">
                <ClientDetails formik={formik} />
              </AccordionDetails>
            </Accordion>

            <Accordion
              className="mb_20"
              classes={{ root: 'MuiPaper-root-MuiAccordion-root' }}
            >
              <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel3a-content"
                id="panel3a-header"
                className="accordion_h"
              >
                <Typography>Equipment Details</Typography>
              </AccordionSummary>
              <AccordionDetails className="accordion_b">
                <EquipmentDetails
                  formik={formik}
                  devicelist={devicelist}
                  pyranometerSensorlist={pyranometerSensorlist}
                  Edit={state?.Edit}
                />
              </AccordionDetails>
            </Accordion>

            <Accordion
              className="mb_20"
              classes={{ root: 'MuiPaper-root-MuiAccordion-root' }}
            >
              <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel3a-content"
                id="panel3a-header"
                className="accordion_h"
              >
                <Typography>Organization Details</Typography>
              </AccordionSummary>
              <AccordionDetails className="accordion_b">
                <OrganizationDetails formik={formik} />
              </AccordionDetails>
            </Accordion>



            <Accordion
              className="mb_20"
              classes={{ root: 'MuiPaper-root-MuiAccordion-root' }}
            >
              <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel3a-content"
                id="panel3a-header"
                className="accordion_h"
              >
                <Typography>Estimation</Typography>
              </AccordionSummary>
              <AccordionDetails className="accordion_b">
                <Estimation formik={formik} Edit={state?.Edit} />
              </AccordionDetails>
            </Accordion>

            <div className="align_end">
              <button
                type="submit"
                className="save_btn"
                disabled={formik.isSubmitting}
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  gap: '8px',
                  opacity: formik.isSubmitting ? 0.6 : 1,
                  cursor: formik.isSubmitting ? 'not-allowed' : 'pointer',
                }}
              >
                {formik.isSubmitting && (
                  <CircularProgress size={16} style={{ color: '#fff' }} />
                )}
                {formik.isSubmitting ? 'Saving...' : 'Save'}
              </button>
            </div>
          </div>
        </form>
      </div>
    </>
  )
}

export default AddNewPlant
